import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { LoginGate } from "@/components/layout/LoginGate";
import { ToastProvider } from "@/lib/toast";
import { router } from "./routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5_000,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <LoginGate>
          <RouterProvider router={router} />
        </LoginGate>
      </ToastProvider>
    </QueryClientProvider>
  );
}
